import { Button, Input, InputNumber } from 'antd';
import { ComponentCorrespondentImagemService } from 'core/http/service/componetInteraction/ComponentCorrespondentImagem.service';
import Colors from 'enums/Colors';
import { isArray } from 'lodash';
import ComponentCorrespondentImagem from 'models/componentInteraction/ComponentCorrespondentImagem';
import ComponentCorrespondentImagemAlternativas from 'models/componentInteraction/ComponentCorrespondentImagemAlternativas';
import ComponentInteractionModel from 'models/componentInteraction/ComponentInteraction';
import editorConfig from 'pages/diarioBordo/components/textEditor/editorConfig';
import React, { useEffect, useRef, useState } from 'react';
import { MdAdd, MdDeleteForever } from 'react-icons/md';
import ReactQuill from 'react-quill';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1280px;
        gap: 2rem;
    `,

    Title: styled.h1`
        color: ${Colors.Blue};
        font-size: 18px;
        font-weight: 600;
    `,

    Option: styled.div`
        display: flex;
        align-items: center;
        gap: 0.5rem;
    `,

    Imagem: styled.img`
        object-fit: cover;
        width: 160px;
        height: 160px;
        border: 1px solid gray;
        border-radius: 10px;
        cursor: pointer;
    `,
};

interface IComponentCorrespondentImagemAdmin {
    dados: ComponentInteractionModel;
    handleAttComponent: (value: ComponentInteractionModel) => void;
}

const service = new ComponentCorrespondentImagemService();

const ComponentCorrespondentImagemAdmin: React.FC<IComponentCorrespondentImagemAdmin> = ({ dados, handleAttComponent }) => {
    const [component] = useState<ComponentInteractionModel | null>(dados);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [loadingButtonOption, setLoadingButtonOption] = useState<boolean>(false);

    const [idAlt, setIdAlt] = useState<number>(0);

    const handleImagem = async (value: string) => {
        try {
            setLoadingButtonOption(true);
            let correspondent = getCorrespondente();

            if (correspondent) {
                let alternativa = correspondent.alternativas.filter(alt => alt.codigo === idAlt)[0];
                alternativa.base64 = value;

                await service.saveAlternativa(correspondent.codigo, alternativa);

                correspondent.alternativas.map(dadosAlt => {
                    if (dadosAlt.codigo === idAlt) {
                        dadosAlt = alternativa;
                    }

                    return dadosAlt;
                });
            }

            handleAttComponent({ ...dados, correspondentImagem: correspondent } as ComponentInteractionModel);
        } catch (error) {
            console.log('🚀 ~ handleImagem ~ error:', error);
        } finally {
            setLoadingButtonOption(false);
        }
    };

    const handleFrontImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                handleImagem(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const getCorrespondente = (): ComponentCorrespondentImagem | null => {
        const componentInteraction = component;

        if (componentInteraction) {
            const correspondent = componentInteraction.correspondentImagem as ComponentCorrespondentImagem;

            return correspondent;
        }

        return null;
    };

    const handleTextComponent = (value: string, isFeedback: boolean) => {
        let correspondent = getCorrespondente();

        if (correspondent) {
            !isFeedback ? (correspondent.title = value) : (correspondent.feedback = value);
        }

        handleAttComponent({ ...dados, correspondentImagem: correspondent } as ComponentInteractionModel);
    };
    const handleTextAltComponent = (value: string, idAlt: number) => {
        let correspondent = getCorrespondente();

        if (correspondent) {
            let alternativa = correspondent.alternativas.filter(alt => alt.codigo === idAlt)[0];
            alternativa.matchText = value;

            correspondent.alternativas.map(dadosAlt => {
                if (dadosAlt.codigo === idAlt) {
                    dadosAlt = alternativa;
                }

                return dadosAlt;
            });
        }

        handleAttComponent({ ...dados, correspondentImagem: correspondent } as ComponentInteractionModel);
    };
    const handleOrdemAltComponent = (value: number, isOrdemMatch: boolean, idAlt: number) => {
        let correspondent = getCorrespondente();

        if (correspondent) {
            let alternativa = correspondent.alternativas.filter(alt => alt.codigo === idAlt)[0];
            isOrdemMatch ? (alternativa.ordemMatch = value) : (alternativa.ordemFilepath = value);

            correspondent.alternativas.map(dadosAlt => {
                if (dadosAlt.codigo === idAlt) {
                    dadosAlt = alternativa;
                }

                return dadosAlt;
            });
        }

        handleAttComponent({ ...dados, correspondentImagem: correspondent } as ComponentInteractionModel);
    };

    const removeComponent = async (idAlt: number) => {
        let correspondent = getCorrespondente();

        if (correspondent) {
            const { status } = await service.deleteByAlternativa(idAlt);

            if (status === 204) {
                let alternativas = correspondent.alternativas.filter((alt, i) => alt.codigo !== idAlt);
                correspondent.alternativas = alternativas;
            }
        }

        handleAttComponent({ ...dados, correspondentImagem: correspondent } as ComponentInteractionModel);
    };

    const handleAddOtion = async () => {
        try {
            setLoadingButtonOption(true);
            let correspondent = getCorrespondente();

            if (correspondent) {
                let alternativas = correspondent.alternativas;

                const { data, status } = await service.saveAlternativa(
                    correspondent.codigo,
                    new ComponentCorrespondentImagemAlternativas().fromJSON({
                        codigo: -1,
                        base64: '',
                        filepath: '',
                        matchText: '',
                        ordemFilepath: alternativas != null ? alternativas.length + 1 : 1,
                        ordemMatch: alternativas != null ? alternativas.length + 2 : 2,
                    })
                );

                if (status === 201) {
                    if (alternativas && isArray(alternativas)) {
                        alternativas = [...alternativas, data];
                    } else {
                        alternativas = [data];
                    }

                    correspondent.alternativas = alternativas;
                }
            }

            handleAttComponent({ ...dados, correspondentImagem: correspondent } as ComponentInteractionModel);
        } catch (error) {
        } finally {
            setLoadingButtonOption(false);
        }
    };

    return (
        <Styled.Container>
            <Styled.Title>Correspondência de Imagens</Styled.Title>
            <ReactQuill
                placeholder="Digite o título"
                theme="snow"
                style={{ backgroundColor: '#F5F5F5', width: '100%' }}
                modules={editorConfig.modules2}
                formats={editorConfig.formats2}
                value={component?.correspondentImagem?.title}
                onChange={val => {
                    handleTextComponent(val, false);
                }}
            />

            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFrontImageChange}
                style={{ display: 'none' }} // Oculta o input
            />

            {component?.correspondentImagem &&
                isArray(component.correspondentImagem.alternativas) &&
                component.correspondentImagem.alternativas.map((alt, indexAlt) => (
                    <Styled.Option key={alt.codigo ?? indexAlt}>
                        <InputNumber
                            defaultValue={alt.ordemFilepath}
                            style={{ width: '60px', height: '50px', fontSize: '22px' }}
                            size="large"
                            onChange={v => handleOrdemAltComponent(v ?? 0, false, alt.codigo)}
                        />
                        {alt.base64 != null && alt.base64 != '' ? (
                            <Styled.Imagem
                                src={alt.base64}
                                onClick={() => {
                                    fileInputRef.current?.click();
                                    setIdAlt(alt.codigo);
                                }}
                            />
                        ) : (
                            <Button
                                icon={<MdAdd />}
                                size="large"
                                style={{ height: '50px' }}
                                loading={loadingButtonOption && idAlt === alt.codigo}
                                onClick={() => {
                                    fileInputRef.current?.click();
                                    setIdAlt(alt.codigo);
                                }}
                            >
                                Adicione uma imagem
                            </Button>
                        )}

                        <p>=</p>
                        <Input
                            style={{ maxWidth: '64%', height: '50px' }}
                            size="large"
                            placeholder="Texto correspondência"
                            value={alt.matchText}
                            onChange={e => handleTextAltComponent(e.target.value, alt.codigo)}
                        />
                        <InputNumber
                            defaultValue={alt.ordemMatch}
                            style={{ width: '60px', height: '50px', fontSize: '22px' }}
                            size="large"
                            onChange={v => handleOrdemAltComponent(v ?? 0, true, alt.codigo)}
                        />
                        <MdDeleteForever size={32} color={Colors.DeleteRed} cursor={'pointer'} onClick={() => removeComponent(alt.codigo)} />
                    </Styled.Option>
                ))}

            <Button size="large" style={{ maxWidth: 200 }} icon={<MdAdd />} onClick={handleAddOtion} loading={loadingButtonOption}>
                Adicionar nova opção
            </Button>
            <Styled.Title>Feedback</Styled.Title>
            <ReactQuill
                placeholder="Digite o feedback"
                theme="snow"
                style={{ backgroundColor: '#F5F5F5', width: '100%' }}
                modules={editorConfig.modules2}
                formats={editorConfig.formats2}
                value={component?.correspondentImagem?.feedback ?? ''}
                onChange={val => {
                    handleTextComponent(val, true);
                }}
            />
        </Styled.Container>
    );
};

export default ComponentCorrespondentImagemAdmin;
